// removed by extract-text-webpack-plugin
module.exports = {"notification":"Notification__notification___1ByqF"};